import styled from 'styled-components';
import addAlpha from 'utils/addAlpha';
import DefaultSwitch from 'components/Form/Switch';
import DefaultButton from 'components/Buttons/Button';
import DefaultAddButton from 'components/Buttons/AddButton';
import { Body } from 'components/Typography';
import DefaultActionButton from 'components/Buttons/ActionButton';

const actionBarHeight = '6rem';

// TODO: TFR-44 move to container group or do not export
export const Container = styled.div`
  padding: 2rem;
  width: 45.6875rem;
  background: ${({ theme }) => theme.colors.white};
  border-radius: 1.5rem;
  margin: auto auto 7rem auto;
`;

// TODO: TFR-29 add story to component
export const Actions = styled.div`
  position: fixed;
  bottom: 0;
  background: ${({ theme }) => theme.colors.white};
  box-shadow:
    0rem 0.5rem 1rem rgba(0, 0, 0, 0.1),
    0rem 0.5rem 2rem rgba(0, 0, 0, 0.1);
  height: ${actionBarHeight};
  width: 100%;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const WrapperActions = styled.div`
  padding: 2rem;
  width: 45.6875rem;
  display: flex;
  justify-content: flex-end;
`;

// TODO: TFR-46 remove imports in styled.ts if you do not add styles to component
export const Switch = styled(DefaultSwitch)``;

// TODO: TFR-29 add story to component
export const RowBorder = styled.div`
  display: flex;
  padding-left: 1rem;
  justify-content: space-between;
  align-items: center;
  border: 0.0625rem solid #f1f1f1;
  border-radius: 0.75rem;
  margin-bottom: 2rem;
`;

// TODO: TFR-44 move to container group
export const Row = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 2rem;
`;

// TODO: TFR-45:Button make unique name or do not export
export const Button = styled(DefaultButton)`
  margin-left: 1rem;
`;

// TODO: TFR-45:Select make unique name or do not export
export const Select = styled.select<{ error: boolean }>`
  background: ${({ theme }) => theme.colors.navyGreenLight};
  width: 4rem;
  height: 3.5rem;
  font-size: 1.1875rem;
  color: ${({ theme }) => addAlpha(theme.colors.navyGreen, 0.8)};
  border: none;
  appearance: none;
  cursor: pointer;
  text-align-last: center;
  ${({ error, theme }) => error && `border: 1px solid ${theme.colors.redDark}`}
`;

export const RightSelect = styled(Select)`
  border-radius: 0rem 0.75rem 0.75rem 0rem;
  margin-left: 0.0625rem;
`;

export const LeftSelect = styled(Select)`
  border-radius: 0.75rem 0rem 0rem 0.75rem;
  margin-right: 0.0625rem;
`;

// TODO: TFR-44 move to button group
export const AddButton = styled(DefaultAddButton)`
  margin: auto;
`;

// TODO: TFR-45:Label make unique name or do not export
export const Label = styled(Body)`
  margin-right: 2.25rem;
  font-weight: 600;
`;

// TODO: TFR-45:Date make unique name or do not export
export const DateWrapper = styled.div`
  display: flex;
  align-items: center;
  :last-child {
    margin-left: 4rem;
  }
`;

// TODO: TFR-44 move to button group
export const ActionButton = styled(DefaultActionButton)`
  border-radius: 0.75rem;
  margin-left: 2rem;
`;
